import { ResponsiveView } from '@gower/react-ui/template/responsive-view';
import { provider } from './store';
import { PayoutInvoicesDesktop } from './desktop';
import { PayoutInvoicesMobile } from './mobile';

export const PayoutInvoicesView = provider( () => {

    return <>
        <ResponsiveView
            desktop={PayoutInvoicesDesktop}
            mobile={PayoutInvoicesMobile}
        />
    </>;
} );
